/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  captureException,
  setExtras,
  showReportDialog,
  withScope,
} from '@sentry/react';
import React from 'react';
import TopLevelErrorMessage from './TopLevelErrorMessage';

type ErrorBoundaryProps = {
  children: any;
};
type ErrorBoundaryState = {
  hasErrors: boolean;
};

class MainErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasErrors: false,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasErrors: true };
  }

  // See: https://docs.sentry.io/platforms/javascript/react/
  componentDidCatch(error: Error, errorInfo: any) {
    console.log('Error caught');
    withScope((scope) => {
      setExtras(errorInfo);
      const eventId = captureException(error);
      showReportDialog({
        eventId,
        title: 'Help us fix it?',
        subtitle: 'Our developers have been informed.',
        subtitle2:
          'If you have two minutes, we would appreciate if you can give us some more details around what happened, and a way to get in touch with you',
        labelName: 'Name',
        labelEmail: 'E-mail',
        labelComments: 'What happened?',
        labelClose: 'Close',
        labelSubmit: 'Send',
        successMessage: 'Your report has been submitted. Thank you!',
      });
    });
  }

  render() {
    const { hasErrors } = this.state;
    if (hasErrors) {
      console.log('Returning TopError');
      return <TopLevelErrorMessage />;
    }
    const { children } = this.props;
    return children;
  }
}

export default MainErrorBoundary;
